import { module } from 'modujs';
import Plyr from 'plyr';
import 'plyr/dist/plyr.css';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            click: {
                // play: 'play',
            }
        }

        this.player = null;
    }

    init() {
        this.player = new Plyr(this.el);
    }

    initModal(target) {
        this.player = new Plyr(target);
    }
}
